module.exports = __webpack_public_path__ + "img/mockup-reucirs.dd57594d.png";